import * as React from 'react';

import RetentionPolicyNonModifiable32 from './RetentionPolicyNonModifiable32';

export const retentionPolicyNonModifiable32 = () => <RetentionPolicyNonModifiable32 />;

export default {
    title: 'Icon/Content/RetentionPolicyNonModifiable32',
    component: RetentionPolicyNonModifiable32,
    parameters: {
        notes:
            "`import RetentionPolicyNonModifiable32 from 'box-ui-elements/es/icon/content/RetentionPolicyNonModifiable32';`",
    },
};
